<template>
  <v-row justify="center" class="joinform-page">
    <v-card
      width="100%"
      class="text-xs-center mt-8 elevation-12"
      max-width="600px"
    >
      <v-row class="ma-0 mb-10 mt-8" justify="center">
        <v-col cols="12" class="px-8 py-0 text-center">
          <v-progress-circular
            v-if="status == 'loading'"
            indeterminate
            color="primary"
          ></v-progress-circular>

          <v-alert v-else dense outlined :type="alertType">
            {{ message }}
          </v-alert>

          <div v-if="status == 'success'" class="mt-3 continue-guide">
            확인 버튼을 누르면 인증 창이 닫힙니다.<br />
            열어두신 회원가입 화면에서 가입을 계속 진행해 주세요.
          </div>
        </v-col>
      </v-row>
      <template v-if="status == 'success'">
        <v-divider></v-divider>
        <v-row justify="center" class="ma-0 px-6 py-4">
          <i-btn color="primary" @click="closeTab">확인</i-btn>
        </v-row>
      </template>
      <template v-else-if="status == 'fail'">
        <v-divider></v-divider>
        <v-row justify="center" class="ma-0 px-6 py-4">
          <i-btn color="primary" @click="goSignupPage">
            회원가입 다시 진행
          </i-btn>
        </v-row>
      </template>
    </v-card>
  </v-row>
</template>

<script>
import { getJson } from '@/api/network';

export default {
  data() {
    return {
      status: 'loading', // 'loading' | 'success' | 'fail'
      code: '',
      message: '',
    };
  },
  created() {
    this.verify();
  },
  computed: {
    alertType() {
      if (this.status == 'success') {
        // 이미 예전에 인증된 링크를 다시 눌러 확인 중인 경우 - 방금 인증된 것과 구분해 차분한 색으로 표시한다.
        return this.code == 'ALREADY' ? 'info' : 'success';
      }
      return 'error';
    },
  },
  methods: {
    verify() {
      const token = this.$route.query.token;

      if (!token) {
        this.status = 'fail';
        this.message = '유효하지 않은 인증 링크입니다.';
        return;
      }

      getJson(
        'api/login/' + this.$route.params.tenantKey + '/join/vue/verify',
        { token },
      )
        .then(res => {
          if (
            res.data != null &&
            res.data.hasOwnProperty('status') &&
            res.data.status == 'success'
          ) {
            this.status = 'success';
            this.code = res.data.code;
            this.message =
              this.code == 'ALREADY'
                ? '이미 인증이 완료된 계정입니다.'
                : '이메일 인증이 완료되었습니다.';
          } else {
            this.status = 'fail';
            this.message = res.data && res.data.message;
          }
        })
        .catch(error => {
          console.log(error.response);
          this.status = 'fail';
          this.message = '인증 처리 중 오류가 발생했습니다.';
        });
    },
    goSignupPage() {
      this.$router.push({
        name: 'signup',
        params: { tenantKey: this.$route.params.tenantKey },
      });
    },
    closeTab() {
      // 브라우저 정책상 스크립트로 열리지 않은 탭은 닫히지 않을 수 있다.
      // 그 경우를 대비해 화면의 안내 문구로 "직접 닫고 원래 탭으로 돌아가라"는 대안을 함께 제공한다.
      window.close();
    },
  },
};
</script>

<style scoped>
.continue-guide {
  font-size: 14px;
  line-height: 22px;
  color: #6b7280;
}
</style>
